import React, { FC } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql'
import { PLANTS_USP_SKUS } from '@moonpig/web-core-brand/config'
import { type ModuleUSPList, type ModuleContext } from '../types'
import { useProductStore } from '../../contexts/product'
import { FlowersUSPContent } from '../../components/FlowersUSP'

type Props = {
  module: ModuleUSPList
  context: ModuleContext
}

export const USPListModule: FC<Props> = () => {
  const [{ product }] = useProductStore()

  const isFlowersOrPlants =
    product.category.department === DepartmentsEnum.FLOWERS ||
    product.category.department === DepartmentsEnum.ALL_FLOWERS_AND_PLANTS
  const isPlant = PLANTS_USP_SKUS.includes(product.id)

  return (
    <>
      {isFlowersOrPlants ? (
        <Box data-testid="module-usp-list" mb={6}>
          <FlowersUSPContent isPlant={isPlant} />
        </Box>
      ) : null}
    </>
  )
}
